import React, { FC, createElement, ReactNode } from 'react';
import PrimaryButton from './button/primaryButton';

export type ClassNameType = string;
export type ChildrensType = ReactNode;

export interface IFormProps {
  children?: ChildrensType | any;
  buttonLabel?: string;
  methods: any;
  onSubmit?: any;
  onClick?: any;
  icon?: JSX.Element;
  rowdisplay?: boolean; // To display input elements row wise in the form which is using Modals
  styles?: ClassNameType;
  buttonDisabled?: boolean;
  customStyles?: string;
}

const Form: FC<IFormProps> = ({
  buttonLabel = 'Submit',
  children,
  onSubmit,
  methods,
  onClick,
  icon,
  rowdisplay,
  styles,
  buttonDisabled = false,
  customStyles,
  ...rest
}) => {
  return (
    <form
      onSubmit={methods.handleSubmit(onSubmit)}
      {...rest}
      className={rowdisplay ? `${styles} flex items-start` : ''}
    >
      <div className={rowdisplay ? 'grid grid-cols-2 gap-4 mr-8' : `pb-10 ${customStyles}`}>
        {Array.isArray(children)
          ? children.map((child) => {
              return child?.props?.name
                ? createElement(child?.type, {
                    ...{
                      ...child?.props,
                      methods,
                      key: child?.props?.name
                    }
                  })
                : child;
            })
          : children &&
            createElement(children?.type, {
              ...{
                ...children?.props,
                methods,
                key: children?.props?.name
              }
            })}
      </div>
      <PrimaryButton
        buttonLabel={buttonLabel}
        onClick={onClick}
        iconLeft={icon}
        variant="default"
        size={rowdisplay ? 'my-4 px-8 ml-auto' : 'w-full bold flex items-center justify-center'}
        disabled={buttonDisabled}
      />
    </form>
  );
};

export default Form;
